import React, { useState } from "react";
import styles from "./NewUIHotelCard.module.scss";
import imgNotFound from "../../../assets/images/single-image.png";
import { Link } from "react-router-dom";
import { formatIndianCurrency } from "../../../utils/utils";

const NewUIHotelCard = ({
  item,
  key,
  bookingData,
  handleViewRoomsClickHandler,

}) => {
  const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    item?.hotel_address
  )}`;

  const [openAmenitiesPopup, settOpenAmenitiesPopup] = useState(false);

  return (
    <div className={styles.listing_card} key={key}>
      <div className={styles.img_sec}>
        {/* <img src="/images/hotel-img.png" alt="hotel-img" fill={true} /> */}
        <img
          src={item.hotel_image[0] ? item.hotel_image[0] : imgNotFound}
          alt="hotel-img"
        />
      </div>
      <div className={styles.content_sec}>
        <div className={styles.desc_sec}>
          <div className={styles.rating}>
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 0.5L8.5716 5.33688H13.6574L9.5429 8.32624L11.1145 13.1631L7 10.1738L2.8855 13.1631L4.4571 8.32624L0.342604 5.33688H5.4284L7 0.5Z"
                fill="#ECB119"
              />
            </svg>
            {item?.hotel_rating ? Number(item?.hotel_rating) : 0} Star
          </div>
          <div className={styles.property_name}>
            {" "}
            <h4>{item?.hotel_name}</h4>
            <Link
              className={styles.location}
              to={googleMapsUrl}
              target="_blank"
            >
              <div>
                {" "}
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_5983_7301"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_5983_7301)">
                    <path
                      d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                      fill="#888888"
                    />
                  </g>
                </svg>
              </div>
              <small>{item?.hotel_address}</small>
            </Link>
          </div>
          <div className={styles.amenities}>
            {item?.hotel_amenities?.property_amenity
              ?.slice(0, 5)
              ?.map((amenity, index) => (
                <li className="w-half" key={index}>
                  {amenity}
                </li>
              ))}

            {item?.hotel_amenities?.property_amenity?.length > 5 && (
              <li className="w-half">
                <button onClick={() => settOpenAmenitiesPopup(!openAmenitiesPopup)}>View All</button>
              </li>
            )}

            {openAmenitiesPopup && (
              <div className="popup_backdrop">
                <div className="popup_section">
                  {item?.hotel_amenities?.property_amenity && item?.hotel_amenities?.property_amenity?.length > 0 && (
                    <>
                      <div className="agent">
                        <div>
                          <h6 style={{ fontSize: "16px" }}>
                            Hotel Amenities
                          </h6>
                        </div>
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          onClick={() => settOpenAmenitiesPopup(!openAmenitiesPopup)}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 13L13 1"
                            stroke="#AAAAAA"
                            strokeWidth="1.2"
                          />
                          <path
                            d="M13 13L0.999999 1"
                            stroke="#AAAAAA"
                            strokeWidth="1.2"
                          />
                        </svg>
                      </div>
                      <div className="flex flex_direction_col justify_content_between flex_wrap">
                        <ul className="flex flex_wrap" style={{ paddingLeft: '0' }}>
                          {item?.hotel_amenities?.property_amenity.map((amenity, index) => (
                            <li style={{ width: '50%', fontSize: '12px', color: 'rgb(85, 85, 85)', listStyle: 'none' }} key={index}>
                              {amenity}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
          {/* <div className={styles.distance}>
            <span>7 km from City Center</span>
          </div> */}
        </div>
        <div className={styles.pricing_sec}>
          <div className={styles.pricing_sec_data}>
            {" "}
            {/* <div className={styles.discount_btn}>20% off</div> */}
            <div className={styles.price_details}>
              <span>Starting From</span>
              <h3 className="text_left">{formatIndianCurrency(item?.starting_price)}</h3>
              <small>+ Tax</small>
            </div>
          </div>
          <div className={styles.pricing_second_data}>
            <button
              onClick={() => handleViewRoomsClickHandler(item)}
              className={styles.view_btn}
              type="submit"
            >
              View Rooms
            </button>
            {/* <span>Login Now & Save Extra</span> */}
          </div>
        </div>
      </div>
    </div >
  );
};

export default NewUIHotelCard;


// const handleViewRoomsClickHandler = async (hotel) => {
//   let hasChildAgeError = false;
//   const childAge = bookingData?.childAge;
//   const sanitizedChildAges = childAge
//     .map((age) => (age !== "" ? age : null))
//     .filter((age) => age !== null);

//   const childAgeParams = sanitizedChildAges
//     .map((age, index) => {
//       if (age > 12) {
//         alert("Child age must be between 0 and 12");
//         hasChildAgeError = true;
//         return;
//       }
//       return `&childAge[${index + 1}]=${age}`;
//     })
//     .join("");

//   if (hasChildAgeError) {
//     alert("Child age must be between 0 and 12");
//     return;
//   }

//   try {
//     const url = `/single-hotel/${hotel?.hotel_slug}?hotelId=${hotel?.hotel_id}&location=${bookingData.location}&room=${bookingData.room}&adult=${bookingData.adult}&children=${bookingData.children}${childAgeParams}&checkinDay=${bookingData.checkinDay}&checkinMonth=${bookingData.checkinMonth}&checkinYear=${bookingData.checkinYear}&checkoutDay=${bookingData.checkoutDay}&checkoutMonth=${bookingData.checkoutMonth}&checkoutYear=${bookingData.checkoutYear}&hotel_name=${hotel.hotel_name}&hotel_address=${hotel.hotel_address}`;

//     window.open(url, "_blank");
//   } catch (error) {
//     console.error("Error fetching data:", error);
//     // setLoader(false);
//   } finally {
//     // setLoader(false);
//   }
// };